import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const visible = useRef(false);

  useEffect(() => {
    const isTouch = window.matchMedia(
      "(hover: none) or (pointer: coarse)"
    ).matches;
    if (isTouch) return;

    const dot = dotRef.current;
    const ring = ringRef.current;

    const moveCursor = (e) => {
      if (!visible.current) {
        gsap.set([dot, ring], { opacity: 1 });
        visible.current = true;
      }
      gsap.to(dot, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.08,
        ease: "none",
      });
      gsap.to(ring, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.35,
        ease: "power2.out",
      });
    };

    const grow = () => {
      gsap.to(ring, {
        scale: 2.5,
        borderColor: "rgba(226, 69, 39, 0.25)",
        duration: 0.35,
        ease: "power2.out",
      });
      gsap.to(dot, {
        scale: 0.4,
        backgroundColor: "#E24527",
        duration: 0.25,
      });
    };

    const shrink = () => {
      gsap.to(ring, {
        scale: 1,
        borderColor: "rgba(232, 224, 212, 0.15)",
        duration: 0.35,
        ease: "power2.out",
      });
      gsap.to(dot, {
        scale: 1,
        backgroundColor: "#E8E0D4",
        duration: 0.25,
      });
    };

    const handleOver = (e) => {
      if (e.target.closest("a, button, [data-hover]")) grow();
    };
    const handleOut = (e) => {
      if (e.target.closest("a, button, [data-hover]")) shrink();
    };

    window.addEventListener("mousemove", moveCursor);
    document.addEventListener("mouseover", handleOver);
    document.addEventListener("mouseout", handleOut);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      document.removeEventListener("mouseover", handleOver);
      document.removeEventListener("mouseout", handleOut);
    };
  }, []);

  return (
    <>
      <div
        ref={dotRef}
        className="fixed top-0 left-0 w-2 h-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-cream pointer-events-none z-[200] opacity-0 mix-blend-difference"
      />
      <div
        ref={ringRef}
        className="fixed top-0 left-0 w-10 h-10 -translate-x-1/2 -translate-y-1/2 rounded-full border border-brand-cream/15 pointer-events-none z-[199] opacity-0 mix-blend-difference"
      />
    </>
  );
};

export default CustomCursor;